export default __webpack_public_path__ + "3a8c515.png";